/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
//  */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.


export const environment = {
  production: false,

  // apiUrl: 'http://localhost:7077',

  // apiUrl: 'http://localhost:7062', 

  // apiUrl: 'https://api.postprop.in/lhs_fi',

  apiUrl: 'https://api.postprop.in/vserv',

  // here lhs_fi is war file name
  // apiUrl: 'http://103.228.112.178:7070/fixed-assets-management-ERP-0.0.1-SNAPSHOT',

  // ng build --prod --aot --outputHashing=all
  // apiUrl : 'http://167.85.53.48:7077/lhs_fi'
  
};

